<template>
  <div class="kinds-content">
    <img v-if="false" :src="categoryImg" width="100%" />
    <div v-if="false">
      <CommonHeader title="NBA策略地图" source="用户提供" :no-feedback="true" />
      <flow-chart :type="fcType" />
    </div>
    <div>
      <van-uploader
        v-if="false"
        :max-size="30 * 1024 * 1024"
        :after-read="afterReadFile"
        :max-count="9"
        :preview-image="false"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp4"
        @oversize="onOversize"
      >
        <van-button icon="plus" type="primary">上传文件</van-button>
      </van-uploader>
    </div>
    <van-tabs
      v-if="visibleProducts.length > 1"
      type="card"
      color="#aa341b"
      class="product-tabs"
      @click="setCurrentTab"
    >
      <van-tab
        v-if="hasMergedBrintellixProduct"
        title="Brintellix/Lexapro"
        class="product-tab"
      >
        <BrintellixVue
          v-if="currentTab === 'Brintellix/Lexapro'"
          :product-id="getProductIdForText('Brintellix/Lexapro')"
          @refreshTasks="getTasks"
        />
      </van-tab>
      <van-tab
        v-if="showProductText.indexOf('Azilect') > -1"
        title="Azilect"
        class="product-tab"
      >
        <azilect-vue
          v-if="currentTab === 'Azilect'"
          :product-id="getProductIdForText('Azilect')"
        />
      </van-tab>
      <van-tab
        v-if="showProductText.indexOf('Ebixa') > -1"
        title="Ebixa"
        class="product-tab"
      >
        <ebixa-vue
          v-if="false && currentTab === 'Ebixa'"
          :product-id="getProductIdForText('Ebixa')"
        />
      </van-tab>
    </van-tabs>
    <div v-else-if="visibleProducts.length == 1" class="product-tabs">
      <div class="product-one">{{ visibleProducts[0].product_name }}</div>
      <div class="product-tab">
        <azilect-vue
          v-if="currentTab === 'Azilect'"
          :product-id="visibleProducts[0].product_id"
        />
        <BrintellixVue
          v-if="currentTab === 'Brintellix/Lexapro'"
          :product-id="visibleProducts[0].product_id"
          @refreshTasks="getTasks"
        />
        <ebixa-vue
          v-if="false && currentTab === 'Ebixa'"
          :product-id="visibleProducts[0].product_id"
        />
      </div>
    </div>
    <Nodata v-else :empty-txt="$t('no_data')" />
    <div v-if="tasks" class="product-tabs">
      <CommonHeader
        :title="$t('perception_action_suggestions')"
        icon-url="/lundbeck/NBA/physician.png"
        :no-feedback="true"
      />
      <div class="nba-pannel">
        <div v-if="false" class="visit-kpi-box">
          <div class="visit-kpi-title">拜访任务</div>
          <div class="visit-kpi-row">
            <div class="visit-kpi-item">
              <div class="visit-kpi-label">本月目标</div>
              <div class="visit-kpi-value">{{ 0 }}</div>
            </div>
            <div class="visit-kpi-item">
              <div class="visit-kpi-label">本月已拜访</div>
              <div class="visit-kpi-value">{{ 0 }}</div>
            </div>
            <van-button
              type="primary"
              size="small"
              class="visit-kpi-btn"
              @click="goToVisit"
            >前往拜访</van-button>
          </div>
        </div>
        <p v-if="tasks.length" class="nba-title">{{ $t('perception_online_tasks') }}</p>
        <TaskList
          :tasks="tasks"
          @refreshTasks="getTasks"
          @refreshTyping="refreshCurrentTyping"
        />
        <p v-if="tasks.length === 0" class="nba-no-task">{{ $t('perception_no_tasks') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import Nodata from "@/components/Nodata";
import * as py from "@/api/Physicians";
// import SegType from '@/components/SegType';
import CommonHeader from "@/components/CommonHeader";
import sortDynamicMixins from "@/mixins/sortDynamicMixins";
import FlowChart from "./flowChart.vue";
import { Tabs, Tab, Uploader, Button } from "vant";
import AzilectVue from "./NBA/Azilect.vue";
import BrintellixVue from "./NBA/Brintellix.vue";
import EbixaVue from "./NBA/Ebixa.vue";
import { getLocalStorage } from "@/utils/index";
import { s3Service } from "@/utils/aws/index";
import TaskList from './NBA/TaskList.vue';
import { getPhysicianTasks } from '@/api/nba';

export default {
  name: "ProfileDetailsTyping",
  components: {
    CommonHeader,
    FlowChart,
    AzilectVue,
    EbixaVue,
    BrintellixVue,
    vanTabs: Tabs,
    vanTab: Tab,
    vanUploader: Uploader,
    vanButton: Button,
    Nodata,
    TaskList,
  },
  mixins: [sortDynamicMixins],
  data() {
    return {
      categoryImg: require("../../../assets/lundbeck/category.png"),
      showProduct: [],
      showProductText: "",
      currentTab: "",
      tasks: null,
    };
  },
  computed: {
    physicianId() {
      return this.$route.query.physician_id;
    },
    userId() {
      return getLocalStorage("user_id");
    },
    hasMergedBrintellixProduct() {
      return this.hasProduct('Brintellix') || this.hasProduct('Lexapro');
    },
    visibleProducts() {
      const products = this.showProduct.filter((item) => !['Brintellix', 'Lexapro'].includes(item.product_name));
      if (this.hasMergedBrintellixProduct) {
        const mergedSource = this.showProduct.find((item) => item.product_name === 'Brintellix') ||
          this.showProduct.find((item) => item.product_name === 'Lexapro');
        products.unshift({
          product_id: mergedSource.product_id,
          product_name: 'Brintellix/Lexapro'
        });
      }
      return products;
    }
  },
  created() {},
  mounted() {
    this.getShowProduct();
  },
  methods: {
    getShowProduct() {
      if (!this.userId) {
        this.$router.push({
          path: "/error",
          query: {},
        });
      }
      let is_sales = getLocalStorage('is_sales');
      let params = {
        user_id: this.userId,
        physician_id: this.$route.query.physician_id,
      };
      // if (is_sales === '1') {
      //   py.getUserPhysicianProduct(params).then((res) => {
      //     this.showProduct = [];
      //     if (res.value && res.value.length) {
      //       this.showProduct = res.value.map((item) => {
      //         return {
      //           product_id: item.product_id,
      //           product_name: item.product_name,
      //         };
      //       });
      //     }
      //     this.showProductText = JSON.stringify(this.showProduct);
      //     if (this.showProductText) {
      //       this.getCurrentTab();
      //     }
      //   });
      // } else {
      Promise.all([
        py.getUserProduct(getLocalStorage("user_id")),
        py.getProductPhysicians(this.$route.query.physician_id),
      ]).then((res) => {
        this.showProduct = [];
        res[0].value.map((item) => {
          res[1].value.map((el) => {
            if (item.product_id === el.product_id) {
              this.showProduct.push({
                product_id: item.product_id,
                product_name: item.product_name
              });
            }
          });
        });
        this.showProductText = JSON.stringify(this.showProduct);
        if (this.showProductText) {
          this.getCurrentTab();
        }
        this.getTasks();
      });
      // }
    },
    getProductIdForText(text) {
      if (text === 'Brintellix/Lexapro') {
        const mergedProduct = this.showProduct.find((e) => e.product_name === 'Brintellix') ||
          this.showProduct.find((e) => e.product_name === 'Lexapro');
        return mergedProduct ? mergedProduct.product_id : '';
      }
      const product = this.showProduct.find((e) => e.product_name === text);
      return product ? product.product_id : '';
    },
    hasProduct(text) {
      return this.showProduct.some((e) => e.product_name === text);
    },
    getCurrentTab() {
      if (this.showProductText.indexOf("Brintellix") > -1) {
        this.currentTab = "Brintellix/Lexapro";
      } else if (this.showProductText.indexOf("Lexapro") > -1) {
        this.currentTab = "Brintellix/Lexapro";
      } else if (this.showProductText.indexOf("Azilect") > -1) {
        this.currentTab = "Azilect";
      } else if (this.showProductText.indexOf("Ebixa") > -1) {
        this.currentTab = "Ebixa";
      }
    },
    setCurrentTab(name, title) {
      this.currentTab = title;
      this.getTasks();
    },
    afterReadFile(file) {
      // 此时可以自行将文件上传至服务器
      file.status = "uploading";
      s3Service
        .upload(file.file, {
          dirPath: "LFile/nba_content",
          filename:
            file.file.name.substring(0, file.file.name.lastIndexOf(".")) +
            "_" +
            Date.parse(new Date()),
        })
        .then((res) => {
          console.log("res", res);
          if (res.is_success) {
            file.status = "done";
          } else {
            file.status = "failed";
          }
        });
    },
    onOversize() {
      this.$toast("文件大小不能超过 10M");
    },
    goToVisit() {
      // 跳转到拜访页面
      this.$router.push({ path: '/hcp/visit-create', query: { physician_id: this.physicianId } });
    },
    getTasks() {
      this.tasks = null;
      getPhysicianTasks(this.physicianId, this.userId, this.getProductIdForText(this.currentTab), false, 1, 20)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            this.tasks = res.data;
            console.log(this.tasks);
          } else {
            this.tasks = [];
          }
        })
        .catch((error) => {
          console.error('Failed to get tasks:', error);
          this.tasks = [];
        });
    },
    refreshCurrentTyping() {
      if (this.currentTab === 'Brintellix/Lexapro') {
        // 先清空 currentTab
        this.currentTab = null;
        this.$nextTick(() => {
          this.currentTab = 'Brintellix/Lexapro';
          // 可选：重新拉取任务或分型数据
          this.getTasks();
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.product-tabs {
  background-color: #ffffff;
  padding: 10px 20px;
  text-align: center;
  .product-tab {
    margin-top: 20px;
  }
  .product-one {
    margin-top: 0;
  }
  ::v-deep .van-tabs__nav--card {
    overflow: hidden;
  }
  ::v-deep .van-tabs__nav--card .van-tab {
    flex: 1 1 0;
    min-width: 0;
    padding: 0 8px;
    margin: 0;
  }
  ::v-deep .van-tabs__nav--card .van-tab:first-child {
    flex-grow: 1.7;
  }
}
.nba-pannel {
  margin: -10px 0 -2px 0;
  padding: 8px;
  background-color: #f8f6f2;
  border-radius: 0 0 10px 10px;
  .nba-title {
    padding: 2px 0 10px 0;
    margin: 0;
    font-size: 12px;
    display: block;
    font-weight: 700;
    color: #aa341b;
    text-align: center;
  }
  .action-text {
    padding: 10px;
    margin-bottom: 8px;
    border-radius: 8px;
    background-color: #ffffff;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .nba-no-task {
    padding: 25px 10px;
    color: #999;
    // background-color: #ffffff;
  }
}
.visit-kpi-box {
  .visit-kpi-title {
    color: #aa341b;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .visit-kpi-row {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 10px 20px;
    margin-bottom: 18px;
    border-radius: 8px;
    background-color: #ffffff;
  }
  .visit-kpi-item {
    flex: 0 0 auto;
    .visit-kpi-label {
      color: #888;
      font-size: 13px;
      margin-bottom: 2px;
    }
    .visit-kpi-value {
      color: #2c3034;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .visit-kpi-btn {
    margin-left: auto;
    background: #aa341b;
    border-radius: 20px;
    font-size: 14px;
    padding: 0 18px;
    height: 32px;
    line-height: 32px;
    border: none;
  }
}
</style>
